import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Launchoperatereal() {
  return (
    <section className="launch_operate_real p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Get a Complete Digital Solution to Scale, Automate & Grow Your
              <span> Retail Business</span>
            </h2>
            <p>
              Empower your retail operations with a custom app designed to
              enhance customer experiences, boost sales, and streamline
              processes. TekRevol's retail app development services provide you
              with the tools to manage inventory, engage customers, and drive
              growth with modern, secure technology.
            </p>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={6}
            xxl={5}
            className="m-auto text-center"
          >
            <div className="retail-business-list">
              <ul>
                <li>Customizable User Interface</li>
                <li>Real-Time Inventory Sync </li>
                <li>Secure Payment Gateways</li>
                <li>Automated Loyalty Programs</li>
              </ul>
            </div>
          </Col>

          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-4"
          >
            <StaticImage
              src="../../images/services-usa/retail-app/retail-business.webp"
              alt="tekrevol_web"
              className="d-none d-md-block"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1607}
              height={681}
            />
            <StaticImage
              src="../../images/services-usa/retail-app/retail-buss-mob.webp"
              alt="tekrevol_web"
              className="d-block d-md-none"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1058}
              height={651}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Launchoperatereal;
